<footer>
    <span>
        &copy; Copyright {{ dateYear }}, Global Login 
    </span>
</footer>
